import { render } from "./DashboardOne.vue?vue&type=template&id=3ebe25e0"
import script from "./DashboardOne.vue?vue&type=script&lang=js"
export * from "./DashboardOne.vue?vue&type=script&lang=js"

import "./DashboardOne.vue?vue&type=style&index=0&id=3ebe25e0&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__